import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ALERT_FEATURE_KEY, alertReducer } from './+state/alert.reducer';
import { AlertEffects } from './+state/alert.effects';

/**
 * Standalone providers for the `alert` NgRx feature slice (SEOMS-437).
 * Replaces the former `AlertStoreModule`.
 */
export function provideAlertStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(ALERT_FEATURE_KEY, alertReducer),
    provideEffects([AlertEffects]),
  ]);
}
